/* eslint-disable react-hooks/exhaustive-deps */
import Badge from 'apollo-react/components/Badge';
import IconButton from 'apollo-react/components/IconButton';
import TextField from 'apollo-react/components/TextField';
import ChevronDown from 'apollo-react-icons/ChevronDown';
import ChevronRight from 'apollo-react-icons/ChevronRight';
import EllipsisHorizontal from 'apollo-react-icons/EllipsisHorizontal';
import Trash from 'apollo-react-icons/Trash';
import React, { useEffect, useState } from 'react';

const LabelCell = ({ row, column: { accessor } }) => {
  const { id, toggleRow, editRow, expanded } = row;

  const [value, setValue] = useState(row[accessor]);

  useEffect(() => {
    setValue(row[accessor]);
  }, [row[accessor]]);

  return (
    <TextField
      size="small"
      fullWidth
      value={value}
      icon={
        expanded ? <ChevronDown fontSize="extraSmall" /> : <ChevronRight fontSize="extraSmall" />
      }
      iconProps={{
        onClick: () => toggleRow(id),
        size: 'small',
      }}
      onChange={({ target }) => setValue(target.value)}
      onBlur={() => editRow(id, accessor, value)}
      inputProps={{ style: { borderColor: expanded ? 'blue' : '' } }}
    />
  );
};

const ClusterDataCell = ({ row, column: { accessor } }) => {
  const { setModalId, id } = row;
  const clusterData = row[accessor];

  return (
    <Badge badgeContent={Array.isArray(clusterData) ? clusterData.length : 0}>
      <IconButton onClick={() => setModalId(id)}>
        <EllipsisHorizontal />
      </IconButton>
    </Badge>
  );
};

const ActionCell = ({ row: { id, deleteRow } }) => (
  <IconButton onClick={() => deleteRow(id)}>
    <Trash />
  </IconButton>
);

export const columns = [
  {
    header: 'Label',
    accessor: 'label',
    customCell: LabelCell,
  },
  {
    header: 'Cluster Data',
    accessor: 'clusterData',
    customCell: ClusterDataCell,
  },
  {
    accessor: 'action',
    customCell: ActionCell,
    align: 'right',
  },
];
